import type { HeaderProps } from '../types';

import { CasinoBanner } from './CasinoBanner';

export const GenericBanner = ({ openSignUp }: HeaderProps) => {
  return <CasinoBanner openSignUp={openSignUp} />;
};
